/**
 * Prefijos de hilo del asunto (RE:/RV:/FW:/FWD:), sin acumular.
 *
 * Antes cada respuesta o reenvío anteponía su prefijo al asunto que ya
 * traía el original, así que responder dos veces dejaba "RE: RE: ...". Aquí
 * se quita todo lo acumulado y se antepone un único prefijo.
 */

/** Prefijos de hilo: RE, RV, FW, FWD con [n] opcional. Misma lista que
 *  email-integration-backend/src/utils/subject.ts SIN `ref`, porque en
 *  logística "REF: 12345" es un asunto legítimo. */
export const SUBJECT_THREAD_PREFIXES = /^\s*(?:(?:re|rv|fw|fwd)\s*(?:\[\d+\])?\s*:\s*)+/i;

/** Quita todos los prefijos de hilo del inicio del asunto. Solo recorta al inicio. */
export function stripSubjectPrefixes(subject: string | null | undefined): string {
  return (subject ?? '').replace(/[\r\n]+/g, ' ').replace(SUBJECT_THREAD_PREFIXES, '').trim();
}

/** Asunto de una respuesta: un solo `RE:`. */
export function buildReplySubject(subject: string | null | undefined): string {
  const core = stripSubjectPrefixes(subject);
  return core ? `RE: ${core}` : 'RE:';
}

/** Asunto de un reenvío: `FW:` en inglés, `RV:` en cualquier otro idioma. */
export function buildForwardSubject(subject: string | null | undefined, locale: string): string {
  const prefix = locale.toLowerCase().startsWith('en') ? 'FW' : 'RV';
  const core = stripSubjectPrefixes(subject);
  return core ? `${prefix}: ${core}` : `${prefix}:`;
}

/** Asuntos que no identifican una conversación: nunca unen correos entre sí. */
const SUBJECTS_WITHOUT_THREAD = new Set(['', '(sin asunto)', '(no subject)']);

/**
 * Llave de asunto para unir en un hilo los correos que el proveedor separó.
 * En Outlook el conversationId es propio de cada buzón y Kila guarda un solo
 * documento por mensaje, así que el mismo hilo puede llegar con varios
 * conversationId. Sin prefijos RE/RV/FW, sin espacios repetidos y en
 * minúsculas. '' si el asunto no sirve para agrupar.
 */
export function threadSubjectKey(subject: string | null | undefined): string {
  const key = stripSubjectPrefixes(subject).normalize('NFC').replace(/\s+/g, ' ').toLowerCase();
  return SUBJECTS_WITHOUT_THREAD.has(key) ? '' : key;
}
